import request from '@/utils/request'


export function fetchInsuredList(query) {
  return request({
    url: '/insured/',
    method: 'get',
    params: query
  })
}

export function createInsured(data) {
  return request({
    url: '/insured/insureds',
    method: 'post',
    data
  })
}

export function fetchInsured(id) {
  return request({
    url: '/insured/insured/' + id,
    method: 'get'
  })
}

export function updateInsured(data, id) {
  return request({
    url: '/insured/insured/' + id,
    method: 'patch',
    data
  })
}

export function deleteInsured(id) {
  return request({
    url: '/insured/insured/' + id,
    method: 'delete'
  })
}

export function batchImportInsured(data) {
  console.log('batchImportInsured')
  return request({
    url: '/insured/batch/import',
    method: 'post',
    timeout: 5000000,
    data
  })
}


